import { render, staticRenderFns } from "./TableProList2.vue?vue&type=template&id=39bafc16&scoped=true"
import script from "./TableProList2.vue?vue&type=script&lang=js"
export * from "./TableProList2.vue?vue&type=script&lang=js"
import style0 from "./TableProList2.vue?vue&type=style&index=0&id=39bafc16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bafc16",
  null
  
)

export default component.exports